import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_picking_tasks_by_orderId_orderLineNumbersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number, orderLineNumbers: number[] }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, StatusId?: number, AccessorialTaskProperty?: { TaskId?: number }, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumbers)) {
      missingRequiredInParams.push('\'orderLineNumbers\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_picking_tasks_by_orderId_orderLineNumbers/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, orderLineNumbers: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, StatusId?: number, AccessorialTaskProperty?: { TaskId?: number }, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumbers)) {
      missingRequiredInParams.push('\'orderLineNumbers\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_picking_tasks_by_orderId_orderLineNumbers/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, orderLineNumbers: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, OrderId?: number, OrderLineNumber?: number, StatusId?: number, AccessorialTaskProperty?: { TaskId?: number }, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.orderLineNumbers)) {
      missingRequiredInParams.push('\'orderLineNumbers\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_picking_tasks_by_orderId_orderLineNumbers/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number, orderLineNumbers: number[]    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
        if(isNil(inParams.orderLineNumbers)) {
          return true; 
        }
      return false;
    }
}
